import { Box } from '@mui/material';

import MailIcon from 'app/assets/icons/mail.svg?react';
import GenderIcon from 'app/assets/icons/gender.svg?react';
import BirthdayIcon from 'app/assets/icons/birthday.svg?react';
import HomeIcon from 'app/assets/icons/home.svg?react';
import NhsNumberIcon from 'app/assets/icons/nhs-number.svg?react';
import PharmacyIcon from 'app/assets/icons/pharmacy.svg?react';
import SmartphoneIcon from 'app/assets/icons/smartphone.svg?react';
import SurgeryIcon from 'app/assets/icons/surgery.svg?react';

import Field from 'app/pages/Patients/pages/PatientsPage/components/PatientDrawer/Field';

export default function PatientInfo(props) {
  const { patient, loading } = props;

  const homeAddress = [patient?.address, patient?.postcode].filter((exist) => exist).join(', ');

  return (
    <Box className="px-32 py-24 flex gap-16 justify-between [&>*]:min-w-[40%]">
      <div className="flex flex-col gap-16">
        <Field icon={MailIcon} title="Email" value={patient?.username} loading={loading} />
        <Field
          icon={SmartphoneIcon}
          title="Telephone"
          value={patient?.telephone}
          loading={loading}
        />
        <Field icon={GenderIcon} title="Gender" value={patient?.gender} loading={loading} />
        <Field
          icon={HomeIcon}
          title="Home Address"
          value={homeAddress}
          type="address"
          loading={loading}
        />
        <Field
          icon={BirthdayIcon}
          title="Date of Birth"
          value={patient?.birthday}
          type="unix"
          loading={loading}
        />
        <Field
          icon={NhsNumberIcon}
          title="NHS Number"
          value={patient?.nhs_number || ''}
          loading={loading}
        />
      </div>
      <div className="flex flex-col gap-16">
        <Field
          capitalize
          icon={PharmacyIcon}
          title="Patient's pharmacy"
          value={patient?.pharmacy_name}
          loading={loading}
        />
        <Field
          icon={SmartphoneIcon}
          title="Pharmacy contact phone"
          value={patient?.pharmacy_telephone}
          loading={loading}
        />
        <Field
          capitalize
          icon={SurgeryIcon}
          title="Patient's surgery"
          value={patient?.surgery_name}
          loading={loading}
        />
        <Field
          icon={SmartphoneIcon}
          title="Surgery contact phone"
          value={patient?.surgery_telephone}
          loading={loading}
        />
      </div>
    </Box>
  );
}
